import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { StyledLabel, StyledLink } from "./_styled";
import { logRelatedTopicsLinkClicked } from "../../util/analytics";

const RightRailRelatedTopics = ({ label, relations, telemetryData }) => {
  if (!relations?.length) {
    return null;
  }

  return (
    <div>
      <StyledLabel element="h2" styledAs="h5" fontFamily="primary">
        {label}
      </StyledLabel>
      {relations.map((relatedTopic) => (
        <StyledLink
          key={relatedTopic.link}
          fontSize="sm"
          linkComponent={Link}
          href={relatedTopic.link}
          onClick={() =>
            logRelatedTopicsLinkClicked({
              ...telemetryData,
              title: relatedTopic.title,
            })
          }
        >
          {relatedTopic.title}
        </StyledLink>
      ))}
    </div>
  );
};

RightRailRelatedTopics.propTypes = {
  label: PropTypes.string,
  telemetryData: PropTypes.object.isRequired,
  relations: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }).isRequired
  ),
};

RightRailRelatedTopics.displayName = "RightRailRelatedTopics";
export default RightRailRelatedTopics;
